import { timeParse } from "d3";
import { gatewayService } from "@/_services/gateway.service";

/**
 * Fetches FEP historical data and updates the given field in the Vue component state.
 *
 * @param {object} _this - Vue component instance or execution context.
 * @param {string} fieldName - Field name to store the fetched data.
 * @param {boolean} fieldShowLoadingName - Boolean flag to indicate loading state.
 */
export function getFEPData(_this, fieldName, fieldShowLoadingName) {
  _this[fieldShowLoadingName] = true;
  gatewayService.market
    .fepHistory({ format: "json" })
    .then(data => {
      if (!data) throw new Error("Invalid response format");
      let parsedData = data.map(d => ({
        ...d,
        date: timeParse("%Y-%m-%d")(d.date),
        ave_date: timeParse("%Y-%m-%d")(d.ave_date),
        id: +timeParse("%Y-%m-%d")(d.date),
        open: +d.close,
        high: +d.close,
        low: +d.close,
        close: +d.close
      }));
      _this[fieldName] = parsedData;
      let lastEntry = parsedData[parsedData.length - 1];
      _this.freight = +lastEntry.freight_bmd;
      _this.tariff = 100 * lastEntry.tariff_bmd;
      _this.comp =
        Math.round(
          ((lastEntry.compensation - lastEntry.cession) * lastEntry.trm_ave) /
            1000
        ) * 1000;
      _this.compRott =
        Math.round(
          ((lastEntry.compensation_center_g2 - lastEntry.cession_center_g2) *
            lastEntry.trm_ave) /
            1000
        ) * 1000;
      _this[fieldShowLoadingName] = false;
    })
    .catch(error => {
      console.error("Error fetching FEP data:", error);
      _this[fieldShowLoadingName] = false;
    });
}
